export default "__VITE_ASSET__HCcmia7Y__"